import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { Asignacion } from '../shared/models/asignacion';
import { Solicitud } from '../shared/models/solicitud';
import { TipoAsignacion } from '../shared/models/tipo-asignacion';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { TipoAsignacionService } from '../shared/services/tipo-asignacion.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { environment } from '../../environments/environment';
import { CrearSedeDto } from '../shared/models/crear-sede-dto';
import { VlanSede } from '../shared/models/vlan-sede-dto';
import { VlanSedeService } from '../shared/services/vlanSede.service';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
@Component({
  selector: 'app-asociar-vlan-sede',
  templateUrl: './asociar-vlan-sede.component.html',
  styleUrls: ['./asociar-vlan-sede.component.css']
})
export class AsociarVlanSedeComponent implements OnInit {
  modalAgregarFormGoup = this.formBuilder.group({
    urlControl: [''],
    servidorControl: ['', Validators.required],
    servicioControl: ['', Validators.required],
    plataformaControl: ['', Validators.required],
    rolControl: ['', Validators.required],
    controlObeservaciones: new FormControl(),
    controlDns: new FormControl(),
    checkDns: new FormControl()
  });

  private codigoListaAmbientes = environment.listaCodigoAmbientes;
  private codigoListaUrl = environment.listaCodigoUrl;
  private codigoListaServidor = environment.listaCodigoServidor;
  private codigoListaServicio = environment.listaCodigoServicio;
  private codigoListaPlataforma = environment.listaCodigoPlataforma;
  private codigoListaRol = environment.listaCodigoRol;
  private urlSubject = new Subject<string>();
  private servidorSubject = new Subject<string>();

  companias: Compania[];
  ciudades: Ciudad[];
  sedes: Sede[];
  vlans: Vlan[];
  crearSedeDto: CrearSedeDto = new CrearSedeDto();
  idCompaniaSeleccionada = -1;
  companiaSeleccionada: Compania = new Compania();
  idCiudadSeleccionada = -1;
  idSedeSeleccionada = -1;
  idAmbienteSelecccionado = -1;
  idVlanSeleccionado = -1;
  ambientes: ListaItem[];
  tiposAsignacion: TipoAsignacion[];
  idTipoAsignacionSeleccionado: number;
  tipoasignacionSeleccionado: TipoAsignacion;
  urls: ListaItem[];
  urlsFiltradas: ListaItem[];
  urlSeleccionado: ListaItem;
  servidores: ListaItem[];
  servidoresFiltrados: ListaItem[];
  servidorSeleccionado: ListaItem;
  servicios: ListaItem[];
  serviciosFiltrados: ListaItem[];
  servicioSeleccionado: ListaItem;
  plataformas: ListaItem[];
  plataformaFiltradas: ListaItem[];
  plataformaSeleccionado: ListaItem;
  roles: ListaItem[];
  rolesFiltrados: ListaItem[];
  rolSeleccionado: ListaItem;
  observaciones: string;
  dns = '';
  asignaciones: Asignacion[] = new Array<Asignacion>();
  agregarActivo = false;
  agregarDns = false;
  modalRef: NgbModalRef;
  solicitudSeleccionada: Solicitud;
  solicitudes: Solicitud[] = new Array<Solicitud>();
  indicadorEdicion = false;
  indexEditar: number;
  lblBotonAgregar: string;
  asignacionesGeneradas: Asignacion[] = new Array<Asignacion>();
  rangoVlan = '';
  error;
  vlansSede: VlanSede[];
  vlansSedeSeleccionadas: VlanSede[] = new Array<VlanSede>();
  sede: Sede = new Sede();

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private tipoAsignacionService: TipoAsignacionService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder, private vlanSedeService: VlanSedeService) { }

  ngOnInit() {
    this.listarCompanias();
    this.listarVlanSedeParametros(null, null, null);
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public listarCiudadaesPorCompania(): void {
    this.seleccionarCompania();
    this.idCiudadSeleccionada = -1;
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.ciudades = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.listarVlanSedeParametros(this.idCompaniaSeleccionada, null, null);
    this.ciudadService.ciudadesPorIdCompania(this.idCompaniaSeleccionada).subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.listarVlanSedeParametros(this.idCompaniaSeleccionada, this.idCiudadSeleccionada, null);
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => this.sedes = resultado
    );
  }

  public llenarListaVlansSedeId() {
    this.crearSedeDto.idVlanSedes = new Array();
    for (const vlanSede of this.vlansSedeSeleccionadas) {
      this.crearSedeDto.idVlanSedes.push(vlanSede.idVlanSede);
    }
  }
  public listarVlanSede(): void {
    this.vlanSedeService.listarVlanSede().subscribe(
      resultado => {
        this.vlansSede = resultado;
        this.vlansSede = this.vlansSede.filter((value, index, self) => self.map(x => x.nombreVlanSede).indexOf(value.nombreVlanSede) == index)
      }
    );
  }
  public listarVlanSedeParametros(idCompania: number, idCiudad: number, idSede: number): void {
    this.vlanSedeService.listarVlanSede().subscribe(
      resultado => {
        this.vlansSede = resultado;
        this.vlansSede = idCompania != null ? this.vlansSede.filter(
          vlanSede => (vlanSede.idCompania == idCompania || vlanSede.idCompania == null)) : this.vlansSede;

        this.vlansSede = idCiudad != null ? this.vlansSede.filter(
          vlanSede => (vlanSede.idCiudad == idCiudad || vlanSede.idCiudad == null)) : this.vlansSede;

        this.vlansSede = idSede != null ? this.vlansSede.filter(
          vlanSede => (vlanSede.idSede == idSede || vlanSede.idSede == null)) : this.vlansSede;

        this.vlansSede = this.vlansSede.filter((value, index, self) => self.map(x => x.nombreVlanSede).indexOf(value.nombreVlanSede) == index)

        let contador = 0;
        let validadorD = false;
        let validadorO = false;
        let validadorDiez = false;
        this.vlansSede.forEach(function (value) {
          if (value.nombreVlanSede.includes('200') && !validadorD) {
            contador++;
            validadorD = true;
          }
          if (value.nombreVlanSede.includes('80') && !validadorO) {
            contador++;
            validadorO = true;
          }
          if (value.nombreVlanSede.includes('10') && !validadorDiez) {
            contador++;
            validadorDiez = true;
          }
        });
        this.vlansSede = this.vlansSede.filter(
          vlanSede => (!vlanSede.nombreVlanSede.includes('200')));
        this.vlansSede = this.vlansSede.filter(
          vlanSede => (!vlanSede.nombreVlanSede.includes('80')));

        this.vlansSede = this.vlansSede.filter(
          vlanSede => (!vlanSede.nombreVlanSede.includes('10')));
        if (contador == 3) {
          let vlanLoopBack: VlanSede = new VlanSede();
          vlanLoopBack.nombreVlanSede = "LOOPBACK";
          vlanLoopBack.idVlanSede=-1;
          this.vlansSede.push(vlanLoopBack);
        }
      }
    );
  }

  setEventTypeLabel() {
    (document.getElementById('EventTypeSelection')
      .getElementsByClassName('ui-multiselect-label-container')[0]
      .getElementsByClassName('ui-multiselect-label')[0]).textContent = this.vlansSedeSeleccionadas.length + ' seleccionadas';
  }

  establecerSede() {
    this.crearSedeDto.sede = this.sedes.find(x => x.idSede == this.idSedeSeleccionada);
    this.listarVlanSedeParametros(this.idCompaniaSeleccionada, this.idCiudadSeleccionada, this.idSedeSeleccionada);
  }
  guardarAsociacionVlanSede() {
    swal({
      title: "Procesando",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)
    this.crearSedeDto.idCompanias = new Array();
    this.crearSedeDto.idCompanias.push(this.idCompaniaSeleccionada);
    this.llenarListaVlansSedeId();
    this.administradorIpService.crearAsociacionVlanSede(this.crearSedeDto).subscribe(
      resultado => {
        this.crearSedeDto = resultado;
        swal("Se asocio correctamente", "Los rangos creados fueron los siguientes : \n" + this.crearSedeDto.rangosCreados.toString(), "success").then(function () {
          // Redirect the user
          window.location.href = "/#/solicitar-ip";
        });
      }, error => {
        swal("Se presento un error", "", "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );

  }



}



// WEBPACK FOOTER //
// ./src/app/asociar-vlan-sede/asociar-vlan-sede.component.ts